import builder from '../builder';
import Calendar from '../../streamline-icons/light/calendar.svg';

export default builder('IconCalendarLight', Calendar);
